import CoverageReasonService from '@/services-http/sdi/CoverageReasonService';

export default {
  name: "CoverageMixin",

  methods: {
    async fetchCoverages() {
      const coverageService = new CoverageReasonService();
      const result = await coverageService.FetchCoverage();
      return result ? result.data : [];
    },
    getCoverageDescriptionById(coverageIdString) {
      const coverageId = parseInt(coverageIdString);

      if (!this.coverages || Array.isArray(this.coverages) && this.coverages.length === 0) return '';

      const coverageFinded = this.coverages.find((coverage) => coverage.id === coverageId);

      if (coverageFinded) return coverageFinded.description;

      return '';
    }
  }
}